import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { UserForwardIcon } from '@fiverr-private/visuals';
import { AppI18n } from '../../../../i18n';

export const SellerReferralBadge = () => (
    <Stack
        backgroundColor="grey_200"
        borderRadius="md"
        borderWidth="sm"
        paddingX="4"
        justifyContent="flexStart"
        alignItems="center"
        cursor="default"
        height={{ default: 'fit-content', md: '32px' }}
        width="fit-content"
    >
        <UserForwardIcon color="grey_900" size="md" />
        <Typography size="b_sm" color="bodyPrimary">
            <AppI18n k="Badges.referrals_badge" />
        </Typography>
    </Stack>
);
